module.exports = __webpack_public_path__ + "static/media/Snowieslogo.b1c690b5.png";